import React, { ReactNode } from "react";
import { Parallax } from "react-scroll-parallax";
import "./layout.css";

const ContainerWithHeaderOnly = ({
  containerTitle,
  children,
  className
}: {
  children: ReactNode;
  className?: string;
  containerTitle?: string;
}) => {
  return (
    <Parallax className={className}>
      <div className="container">
        <h1>{containerTitle}</h1>
        <div>{children}</div>
      </div>
    </Parallax>
  );
};

export default ContainerWithHeaderOnly;
